function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Responsive from 'react-responsive'; // NOTE: These are the breakpoints used in Bootstrap v4.0.0 as seen in
// the documentation (https://getbootstrap.com/docs/4.0/layout/overview/#responsive-breakpoints)

var breakpoints = {
  extraSmall: {
    maxWidth: 575.98
  },
  small: {
    minWidth: 576,
    maxWidth: 767.98
  },
  medium: {
    minWidth: 768,
    maxWidth: 991.98
  },
  large: {
    minWidth: 992,
    maxWidth: 1199.98
  },
  extraLarge: {
    minWidth: 1200
  }
}; // Extra small devices (portrait phones)

var ExtraSmall = function ExtraSmall(props) {
  return React.createElement(Responsive, _extends({}, props, {
    maxWidth: breakpoints.extraSmall.maxWidth
  }));
}; // Small devices (landscape phones)


var Small = function Small(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: breakpoints.small.minWidth,
    maxWidth: breakpoints.small.maxWidth
  }));
}; // Medium devices (tablets)


var Medium = function Medium(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: breakpoints.medium.minWidth,
    maxWidth: breakpoints.medium.maxWidth
  }));
}; // Large devices (desktops)


var Large = function Large(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: breakpoints.large.minWidth,
    maxWidth: breakpoints.large.maxWidth
  }));
}; // Extra large devices (large desktops)


var ExtraLarge = function ExtraLarge(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: breakpoints.extraLarge.minWidth
  }));
};

var LargerThanExtraSmall = function LargerThanExtraSmall(props) {
  return React.createElement(Responsive, _extends({}, props, {
    minWidth: breakpoints.small.minWidth
  }));
};

export { breakpoints, ExtraSmall, Small, Medium, Large, ExtraLarge, LargerThanExtraSmall };
//# sourceMappingURL=index.js.map